import { DEFAULT_LANG } from '@/constants/lang'

// CURRENT_LANG returns the language for
// https://all.accor.com/account/index.fr.shtml#/*
// and https://all.accor.com/account/fr/*
export const CURRENT_LANG = (() => {
  const matchLang = /account\/(?:index\.)?([a-zA-Z-]{2,5})(?:\.shtml)?/.exec(window.location.href)
  return matchLang ? matchLang[1] : DEFAULT_LANG
})()
